import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

export const boundaryCreateWMSOptimizedPendingItemsSelector = (state: AppState) => state.frontendState.mapTools.boundary.boundaryCreateWMSOptimized.pendingItems;
export const useBoundaryCreateWMSOptimizedPendingItemsSelector = () => useSelector(boundaryCreateWMSOptimizedPendingItemsSelector);
